import { AiTableIllustration, GridTableEmptyState } from "@homebound/beam";

export function TakeoffsAiEmptyState() {
  return (
    <GridTableEmptyState
      illustration={<AiTableIllustration />}
      title="No takeoff lines yet"
      description="Takeoff lines will appear here after you upload construction documents and Blueprint AI generates the results."
    />
  );
}
